// extracted by mini-css-extract-plugin
export default {"commonRoundedButtonLink":"DR8IZ","commonRoundedButton":"C6tRV","buttonPrimary":"rWGos C6tRV","buttonLink":"VmNoV DR8IZ rWGos C6tRV"};